<template>
  <div class="discount-coupon">
    <TabsRight
      :options="rightTabsOptions"
      :cur-tab="curTabRight"
      @tabClick="handleTabClick"
    />
    <div
      class="coupons"
      v-if="curTabRight === 'available'"
    >
      <!-- 添加下拉刷新容器 -->
      <div
        class="refresh-container"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
        :style="{ transform: `translateY(${pullDistance}px)` }"
        ref="couponContainer"
      >
        <!-- 下拉刷新指示器 -->
        <div
          class="pull-down-indicator"
          v-if="pullDistance > 0"
        >
          <span v-if="refreshStatus === 'pull'">↓ 下拉刷新</span>
          <span v-else-if="refreshStatus === 'release'">↑ 释放刷新</span>
          <span v-else-if="refreshStatus === 'loading'">↻ 刷新中...</span>
        </div>

        <div class="cards-wrapper">
          <div
            class="cards"
            v-for="(item, index) in rightList"
            :key="index"
          >
            <div class="cards-name">
              <div class="caeds-num">{{ item.deductibleAmountYuan % 1 === 0 ? Math.floor(item.deductibleAmountYuan) + '元' : item.deductibleAmountYuan + '元' }}</div>
              <div class="use-num">满{{ Math.floor(item.usageThresholdNumYuan) }}元可用</div>
            </div>
            <div class="cards-info">
              <div class="cards-name">{{ item.agencyGoodsName }}</div>
              <div class="end-time">{{ item.expirationTime }}过期</div>
            </div>
            <div
              class="use-btn"
              @click="handleUseNone(item.agencyUrl)"
            >
              去使用
            </div>
          </div>
          <div
            v-if="!rightList.length"
            class="rights-blank"
          >
            <Blank text="暂无优惠券权益" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="coupons"
      v-else
    >
      <!-- 不可用权益也添加下拉刷新 -->
      <div
        class="refresh-container"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
        :style="{ transform: `translateY(${pullDistance}px)` }"
        ref="couponContainer"
      >
        <!-- 下拉刷新指示器 -->
        <div
          class="pull-down-indicator"
          v-if="pullDistance > 0"
        >
          <span v-if="refreshStatus === 'pull'">↓ 下拉刷新</span>
          <span v-else-if="refreshStatus === 'release'">↑ 释放刷新</span>
          <span v-else-if="refreshStatus === 'loading'">↻ 刷新中...</span>
        </div>

        <div class="not-use-cards-wrapper">
          <div
            class="not-use-cards"
            v-for="(item, index) in rightList"
            :key="index"
          >
            <div class="cards-name">
              <div class="caeds-num">{{ item.deductibleAmountYuan % 1 === 0 ? Math.floor(item.deductibleAmountYuan) + '元' : item.deductibleAmountYuan + '元' }}</div>
              <div class="use-num">满{{ Math.floor(item.usageThresholdNumYuan) }}元可用</div>
            </div>
            <div class="cards-info">
              <div class="cards-name">{{ item.agencyGoodsName }}</div>
              <div class="end-time">{{ item.expirationTime }}过期</div>
            </div>
            <div class="cards-flag">
              <img
                v-if="item.effectiveStatus === 'EXPIRED'"
                src="../../../assets/img/chargingVoucher/icon_expired.png"
              >
              <img
                v-if="item.effectiveStatus === 'USED'"
                src="../../../assets/img/chargingVoucher/icon_used.png"
              >
            </div>
          </div>
          <div
            v-if="!rightList.length"
            class="rights-blank"
          >
            <Blank text="暂无不可用优惠券权益" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TabsRight from '../../chargingVoucher/components/TabsRight.vue';
import Blank from '../../chargingVoucher/components/Blank.vue';
import {
  getCouponApi
} from '../common/api.js';
export default {
  name: 'DiscountCoupon',
  components: { TabsRight, Blank },
  data() {
    return {
      curTabRight: 'available',
      rightTabsOptions: [
        {
          text: '可用权益',
          key: 'available'
        },
        {
          text: '不可用权益',
          key: 'unAvailable'
        }
      ],
      rightList: [], // 权益类别

      // 下拉刷新相关数据
      pullDistance: 0, // 下拉距离
      refreshThreshold: 60, // 刷新触发阈值
      refreshStatus: 'pull', // 刷新状态: pull(下拉), release(释放), loading(加载中)
      isRefreshing: false, // 是否正在刷新
      startY: 0, // 触摸起始位置
      isTouching: false // 是否正在触摸
    };
  },
  created() {
    this.getCouponList();
  },
  methods: {
    // 获取优惠券列表数据
    getCouponList() {
      const params = {
        isUse: this.curTabRight !== 'available'
      };
      return getCouponApi(params)
        .then(res => {
          this.rightList = res;
        })
        .catch(error => {
          console.error('获取优惠券列表失败:', error);
        });
    },

    // 下拉刷新相关方法
    handleTouchStart(e) {
      // 只有在容器滚动到顶部时才允许下拉刷新
      const container = this.$refs.couponContainer;
      if (container.scrollTop === 0 && !this.isRefreshing) {
        this.isTouching = true;
        this.startY = e.touches[0].pageY;
        this.refreshStatus = 'pull';
      }
    },

    handleTouchMove(e) {
      if (!this.isTouching || this.isRefreshing) return;

      const currentY = e.touches[0].pageY;
      const diff = currentY - this.startY;

      // 只处理向下拉动
      if (diff > 0) {
        e.preventDefault();
        this.pullDistance = Math.min(diff * 0.4, 100); // 限制最大下拉距离

        // 根据下拉距离更新状态
        if (this.pullDistance >= this.refreshThreshold) {
          this.refreshStatus = 'release';
        } else {
          this.refreshStatus = 'pull';
        }
      }
    },

    handleTouchEnd() {
      if (!this.isTouching || this.isRefreshing) return;

      this.isTouching = false;

      // 如果达到刷新阈值，则执行刷新
      if (this.pullDistance >= this.refreshThreshold) {
        this.refreshStatus = 'loading';
        this.isRefreshing = true;

        // 执行刷新操作
        this.refreshData();
      } else {
        // 否则恢复原位
        this.resetPullDown();
      }
    },

    // 重置下拉状态
    resetPullDown() {
      this.pullDistance = 0;
      this.refreshStatus = 'pull';
    },

    // 刷新数据
    refreshData() {
      this.getCouponList().then(() => {
        // 刷新完成后重置状态
        setTimeout(() => {
          this.isRefreshing = false;
          this.resetPullDown();
        }, 500); // 添加短暂延迟以显示加载状态
      }).catch(() => {
        // 出错时也重置状态
        this.isRefreshing = false;
        this.resetPullDown();
      });
    },

    handleTabClick(key) {
      console.log('key', key);
      this.curTabRight = key;
      this.rightList = [];
      this.getCouponList();
    },

    handleUseNone(url) {
      // 跳转购券中心
      this.$parent.curNav = 'CharingCenter';
    }
  }
};
</script>
<style lang="scss" scoped>
.discount-coupon {
  min-height: calc(100vh - 114px);
  background: #f7f7f7;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  .coupons {
    box-sizing: border-box;
    min-height: calc(100vh - 114px);
    padding: 16px 32px 0px 32px;
    padding-bottom: 120px;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  // 下拉刷新容器
  .refresh-container {
    transition: transform 0.3s ease-out;
    min-height: 100%;
    position: relative;
  }

  // 下拉刷新指示器
  .pull-down-indicator {
    position: absolute;
    top: -60px;
    left: 0;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: #999;
  }

  // 卡片容器
  .cards-wrapper,
  .not-use-cards-wrapper {
    padding-top: 20px;
  }

  .not-use-cards {
    width: 100%;
    margin-top: 32px;
    height: 192px;
    box-sizing: border-box;
    // min-height: calc(100vh - 114px);
    padding: 0 17px 0 12px;
    background-image: url('../../../assets/img/pic_unAvailable.png');
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .cards-name {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 8px;

      // max-width: ;
      .caeds-num {
        font-size: 48px;
        color: #FFFFFF;
        text-align: center;
      }

      .use-num {
        margin-top: 12px;
        // margin-left: 8px;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 0.36px;
        text-align: center;
        font-weight: 400;
      }
    }

    .cards-info {
      width: 320px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 16px;
      max-width: 50%;

      .cards-name {
        width: 100%;
        font-size: 32px;
        color: #665857;
        line-height: 1.2;
        word-break: break-word;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .end-time {
        font-size: 24px;
        color: #998B8A;
        letter-spacing: 0.36px;
        font-weight: 400;
        line-height: 1.2;
        margin-top: 16px;
      }
    }

    .cards-flag {
      width: 116px;
      height: 116px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .cards {
    margin-top: 32px;
    height: 192px;
    box-sizing: border-box;
    // min-height: calc(100vh - 114px);
    padding: 0 17px 0 12px;
    background-image: url('../../../assets/img/pic_available.png');
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .cards-name {
      margin-left: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      // max-width: ;
      .caeds-num {
        font-size: 48px;
        color: #FFFFFF;
        text-align: center;
      }

      .use-num {
        margin-top: 12px;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 0.36px;
        text-align: center;
        font-weight: 400;
      }
    }

    .cards-info {
      margin-left: 16px;
      width: 320px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 16px;
      max-width: 50%;

      .cards-name {
        width: 100%;
        font-size: 32px;
        color: #665857;
        line-height: 1.2;
        word-break: break-word;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .end-time {
        font-size: 24px;
        color: #998B8A;
        letter-spacing: 0.36px;
        font-weight: 400;
        line-height: 1.2;
        margin-top: 16px;
      }
    }
  }

  .use-btn {
    margin-right: 8px;
    padding: 18px 13px 14px 13px;
    background-image: linear-gradient(180deg, #EE6C5C 0%, #CB3D2B 100%);
    box-shadow: 0px 2px 4px 1px rgba(206, 69, 52, 0.29);
    border-radius: 30px;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0.36px;
    text-align: center;
    font-weight: 400;
  }

  .rights-blank {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transform: translateY(20vh);

    .buy-coupon-btn {
      background: #fe7256;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      width: 320px;
      height: 90px;
      margin-top: 64px;
    }
  }
}
</style>
